import type { Country, CustomsBrokerType } from '@fv/models'

import type {
  CustomsBroker,
  CustomsBrokerDto,
  FormCustomsBroker,
} from './brokerTypes'

export const customsBrokerMapper = {
  dtoToForm: (broker?: CustomsBrokerDto | null): FormCustomsBroker => ({
    address: broker?.address || '',
    address2: broker?.address2 || '',
    city: broker?.city || '',
    companyName: broker?.companyName || '',
    country: broker?.country,
    email: broker?.email || '',
    phone: broker?.phone?.replace(/\D/g, '') || '',
    phoneExt: broker?.phoneExt || '',
    postalCode: broker?.postalCode || '',
    state: broker?.state || '',
    value: String(broker?.value || ''),
    valueCurrency: broker?.valueCurrency || 'usd',
    type: broker?.type || '',
    addressBookId: broker?.addressBookId || '',
  }),
  formToDTO: (broker: FormCustomsBroker): CustomsBroker | undefined => {
    const address = broker.address.trim()
    const address2 = broker.address2.trim()
    const city = broker.city.trim()
    const country = broker.country?.toLowerCase() ?? '' // bug where country can be nullish
    const email = broker.email.trim()
    const phoneExt = broker.phoneExt.trim()
    const postalCode = broker.postalCode.trim()
    const state = broker.state.trim()
    const value = broker.value.trim()
    const valueCurrency = broker.valueCurrency
    const type = broker.type.trim()
    const companyName = broker.companyName.trim()
    const phone = broker.phone.trim()
    const adminArea3 = broker.adminArea3?.trim()
    const addressBookId = broker.addressBookId

    if (!companyName && !phone) {
      return undefined
    }

    return {
      companyName,
      phone,
      ...(adminArea3 && { adminArea3 }),
      ...(address && { address }),
      ...(address2 && { address2 }),
      ...(city && { city }),
      ...(country && { country: country as Country }),
      ...(email && { email }),
      ...(phoneExt && { phoneExt }),
      ...(postalCode && { postalCode }),
      ...(state && { state }),
      ...(value && {
        value: Number(value),
        valueCurrency: valueCurrency,
      }),
      ...(type && { type: type as CustomsBrokerType }),
      ...(addressBookId && { addressBookId }),
    }
  },
}

export function validateCustomsBroker(
  broker?: CustomsBroker | FormCustomsBroker | null,
) {
  return Boolean(broker?.companyName?.trim() && broker.phone?.trim())
}
